module.exports = __webpack_public_path__ + "static/media/70_zinc_metal_seamless.e620c245.jpg";